var debugView = false;

/////////////////////////////////////////////////////////////////////////////////////////////////////////
// random utils
/////////////////////////////////////////////////////////////////////////////////////////////////////////

// metaobjects index not in order so sort by position
window._breedSelectorData.questions.sort((a, b) => a.position - b.position);

// Add the index property based on the sorted order
window._breedSelectorData.questions.forEach((question, index) => {
    question.index = index + 1; // Assign new sequential index

});

function DOMApply(root, selector, op) {
    var elements = root.querySelectorAll(selector);
    elements.forEach(function (element) {
        op(element);
    });
}
function SetEventHandler(element, event, fn) {
    var key = "__eventhandler_for_" + event + "_" + fn.name;
    if (!(element[key])) {
        element[key] = fn;
        element.addEventListener(event, fn);
    }
}

function SetSelectedSpecialisedElement(element, value) {
    for (var j = 0; j < element.options.length; j++) {
        if (element.options[j].value == value) {
            break;
        }
    }
    if (j == element.options.length) {
        if (element.getAttribute("data-allow-blank") == "true") {
            element.selectedIndex = -1;
        }
        else if (element.getAttribute("data-show-if-missing") == "true") {
            element.classList.add("hidden");

            var p = document.createElement("span");
            p.innerText = value;

            element.parentNode.appendChild(p);
        }
        else {
            element.selectedIndex = 0;
        }
    }
    else {
        element.selectedIndex = j;
    }
}

function SpecialiseDynamicElement(element, value, api)
{
    BS_SendAPIRequest(api, "GET", null, function (err, result) {
        if (result) {
            while (element.firstChild) {
                element.firstChild.remove();
            }

            var valKey = element.getAttribute("data-value-key");
            var nameKey = element.getAttribute("data-name-key");

            result.forEach(function (row) {
                var option = IS_CreateElement("option");
                option.setAttribute("value", SafeGet(row, valKey));
                option.appendChild(document.createTextNode(SafeGet(row, nameKey)));
                element.appendChild(option);
            });
        }
        SetSelectedSpecialisedElement(element, value);

        element._apiData = result;

        if (element._specialisationCB) {
            element._specialisationCB();
        }
    });
}
function ZeroPad(val) {
    var result;
    if (Number(val) < 10) {
        result = "0" + val;
    }
    else {
        result = val.toString();
    }
    return (result);
}
function Undateify(value) {
    var dt = new Date(value);
    var month = dt.getMonth() + 1;
    var day = dt.getDate();

    //var dateStr = dt.getFullYear( ) + "-" + ZeroPad( month.toString( ) ) + "-" + ZeroPad( day );
    var dateStr = dt.getFullYear() + ZeroPad(month.toString()) + ZeroPad(day);
    return (dateStr);
}

function safeGetA(obj, keys) {
    var result;
    if (obj) try {
            // sigh. must be a better way of doing this.
            if ((keys.length > 0) && (keys[0].indexOf)) {
                var arStart = keys[0].indexOf("[");
                if (arStart >= 0) {
                    var ar = keys.shift();
                    var numStart = arStart + 1;
                    var arName = ar.substr(0, arStart);
                    var numEnd = ar.indexOf("]");
                    var numStr = ar.substr(numStart, numEnd - numStart);
                    var idx = Number(numStr);
                    keys.splice(0, 0, idx);
                    if (arStart > 0) {
                        keys.splice(0, 0, arName);
                    }
                }
            }

            if (keys.length == 1) {
                result = obj[keys[0]];
            }
            else {
                var next = keys.shift();
                if (obj[next]) {
                    result = safeGetA(obj[next], keys);
                }
            }
        }
        catch (e) {
            logger.log(logger.LOG_WARNING, "safeGet failed : " + e.stack);
        }
    return (result);
}
function SafeGet(obj, keys) {
    var result;
    if (keys) {
        result = safeGetA(obj, keys.split("."));
    }
    else {
        result = obj;
    }
    return (result);
}
function SafeGetStr(obj, keys, def) {
    var result = SafeGet(obj, keys);
    if (result == undefined) {
        if (def) {
            result = def;
        }
        else {
            result = "";
        }
    }
    return (result);
}

// function navigateToSelectedBreed() {
//     const selectedBreed = document.querySelector('input[name="breed"]:checked');
//     if (selectedBreed) {
//         window.location.href = selectedBreed.value;
//     } else {
//         alert('Please select a breed.');
//     }
// }

// function highlightSelectedBreed(radio) {
//     document.querySelectorAll('.landing-dog-image-container, .landing-cat-image-container').forEach(container => {
//         container.classList.remove('highlighted');
//     });
//     radio.closest('label').querySelector('div').classList.add('highlighted');
// }


function SpecialiseElement(element, data, getter)
{
    var key = element.getAttribute( "data-key" );
    if ( key )
    {
        var value = getter( data, key );
        var type  = element.getAttribute( "data-type" );
        var api   = element.getAttribute( "data-api" );
        
        if ( ( value == undefined ) && ( type == "html" ) )
        {
            $(element).summernote("code", "");
        }
        else if ( ( value == undefined ) && ( api ) )
        {
            // another special case for dynamic elements
            // should probably refactor this function
            if ( api )
            {
                SpecialiseDynamicElement( element, value, api );
            }
        }
        if ( ( type == "list" ) && ( value instanceof Array ) )
        {
            var wrapper = document.createElement( "div" );
            
            while ( element.firstChild )
            {
                wrapper.appendChild( element.firstChild );
            }
            value.forEach( function( childValue )
            {
                var childNode = wrapper.cloneNode( true );
                Specialise( childNode, childValue );

                while( childNode.firstChild )
                {
                    element.appendChild( childNode.firstChild );
                }
            } );
        }
        else
        {
            if ( type == undefined )
            {
                type = element.type;
            }
            if ( value == undefined )
            {
                value = "";
            }

            if ( type == "id" )
            {
                element.setAttribute( "data-id", value );
            }
            else if ( type == "html" )
            {
                $(element).summernote("code", value);
            }
            else if ( type == "proxy" )
            {
                // ignore
            }
            else if ( type == "attribute" )
            {
                var attributeName = element.getAttribute( "data-property" );
                element.setAttribute( attributeName, value );
            }
            else if ( type == "conditional" )
            {
                var condition = element.getAttribute( "data-condition" );
                if ( value != condition )
                {
                    element.remove( );
                }
            }
            else if ( ( element.tagName == "INPUT" ) || ( element.tagName == "SELECT" ) )
            {
                if ( type == "date" )
                {
                    element.value = Undateify( new Date( value ) );
                }
                else if ( ( type == "select" ) || ( element.tagName == "SELECT" ) )
                {
                    var api = element.getAttribute( "data-api" );
                    if ( api )
                    {
                        SpecialiseDynamicElement( element, value, api );
                    }
                    else
                    {
                        SetSelectedSpecialisedElement( element, value );
                    }
                }
                else if ( type == "datetime" )
                {
                    if ( element.getAttribute( "type" ) == "datetime-local" )
                    {
                        element.value = new Date( value ).toISOString( ).substr( 0, 19 );
                    }
                    else
                    {
                        element.value = new Date( value ).toLocaleString( );
                        element.setAttribute( "data-value", new Date( value ).toISOString( ) );
                    }
                }
                else if ( type == "boolean" )
                {
                    if ( value )
                    {
                        element.checked = "checked";
                    }
                }
                else
                {
                    var it = element.getAttribute( "type" );
                    if ( it == "radio" )
                    {
                        if ( value == element.value )
                        {
                            element.checked = true;
                        }
                        else
                        {
                            element.checked = false;
                        }
                    }
                    else if ( it == "checkbox" )
                    {
                        if ( value )
                        {
                            element.checked = true;
                        }
                        else
                        {
                            element.checked = false;
                        }
                    }
                    else
                    {
                        element.value = value;
                        element.setAttribute( "data-value", value ); // for some reason setting "value" is misbehaving
                    }
                }
            }
            else if ( ( element.tagName == "A" ) && ( type == "link" ) )
            {
                var hr = element.getAttribute( "href" );
                if ( hr == undefined )
                {
                    hr = "";
                }
                hr += value;
                element.setAttribute( "href", hr );
            }
            else if ( element.tagName == "IMG" )
            {
                if ( value != "" )
                {
                    // Check if the URL contains "_small" and remove it to replace with the original URL
                    if (value.includes("_small")) {
                        value = value.replace("_small", "");
                    }
                    element.setAttribute( "src", value );
                }
            }
            else if (element.tagName == "TEXTAREA" )
            {
                element.value = value;
            }
            else if ( type == "markup" )
            {
                element.innerHTML = value;
            }
            else
            {
                if ( type == "price" )
                {
                    value = "\u00A3" + value;
                }
                else if ( type == "date" )
                {
                    value = Undateify( new Date( value ) );
                }

                //element.appendChild( document.createTextNode( value ) );
                element.innerText = value;
            }
            element.setAttribute( "data-value", value );
        }
    }
}

function Specialise(root, data) {
    var dynamicElements = root.querySelectorAll(".dynamic_field");

    for (var i = 0; i < dynamicElements.length; i++) {
        var element = dynamicElements[i];
        SpecialiseElement(element, data, SafeGet);
    }
}

function InsertSortedRanged(ar, start, end, entry, comp, options) {
    var size = end - start;
    if (size < 3) {
        // when there are only a few elements just check and decide
        for (var i = start; i < end; i++) {
            var compval = comp(entry, ar[i]);

            if (compval == 0) {
                if ((options) && (options.allowDuplicateKeys)) {
                    ar.splice(i, 0, entry);
                }
                else {
                    ar[i] = entry;
                }
                break;
            }
            else if (compval < 0) {
                ar.splice(i, 0, entry);
                break;
            }
        }
        if (i == end) {
            ar.splice(i, 0, entry);
        }
    }
    else {
        var idx = Math.floor(start + (size / 2));
        var check = ar[idx];
        var compval = comp(entry, check);
        if (compval == 0) {
            // special case for equality: just overwrite
            if ((options) && (options.allowDuplicateKeys)) {
                ar.splice(idx, 0, entry);
            }
            else {
                ar[idx] = entry;
            }
        }
        else if (compval < 0) {
            // partition left
            InsertSortedRanged(ar, start, idx, entry, comp, options);
        }
        else {
            // partition right
            InsertSortedRanged(ar, idx, end, entry, comp, options);
        }
    }
}
function InsertionSort(ar, entry, comp, options) {
    if (ar.length == 0) {
        ar.push(entry);
    }
    else {
        InsertSortedRanged(ar, 0, ar.length, entry, comp, options);
    }
}

function BS_SendAPIRequest(urlPart, method, payload, cb) {
    var url;
    var xhr = new XMLHttpRequest();

    if (urlPart.startsWith("http")) {
        url = urlPart;
    }
    else {
        if (window._apiRoot) {
            url = window._apiRoot + urlPart;
        }
    }

    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            var response;
            var err;
            if (xhr.status == 200) {
                if ((xhr.responseText) && (xhr.responseText.length > 0)) {
                    try {
                        response = JSON.parse(xhr.responseText);
                    }
                    catch (e) {
                        console.log("error parsing response : " + e.stack);
                        err = { "error": e };
                    }
                }
            }
            else {
                err = { "error": xhr.status };

                if ((xhr.responseText) && (xhr.responseText.length > 0)) {
                    try {
                        err.detail = JSON.parse(xhr.responseText);
                    }
                    catch (e) {
                    }
                }
            }

            cb(err, response, xhr);
        }
    };


    if (method == "GET") {
        var qpStr = "?";
        if (payload) {
            for (var key in payload) {
                if (qpStr.length > 1) {
                    qpStr += "&";
                }
                qpStr += key + "=" + encodeURIComponent(payload[key]);
            }

            xhr.open(method, url + qpStr, true);
        }
        else {
            xhr.open(method, url + qpStr, true);
        }

        xhr.setRequestHeader("x-store", Shopify.shop);
        xhr.send();
    }
    else {
        if (!payload) {
            payload = {};
        }

        xhr.open(method, url, true);
        xhr.setRequestHeader("x-store", Shopify.shop);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(payload));
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////
// breed selector results implementation
/////////////////////////////////////////////////////////////////////////////////////////////////////////

function SetAnswerVisibility(selected, available, SPECIES_TYPE) {
    var questions = document.querySelectorAll(".breed-selector-question-template:not( .breed-selector-question-templates *)");

    questions.forEach(function (question) {
        var questionKey = question.querySelector("input[data-key='key']").getAttribute("data-value");
        if (selected[questionKey]) {
            // the user made a choice here, so all the other answer options will be missing from the available set
            // but they should all *be* available, in case the user wants to choose another one
            DOMApply(question, ".breed-selector-answer", function (e) { e.classList.remove("hidden"); }, SPECIES_TYPE);
        }
        else {
            // only show available choices
            var answers = question.querySelectorAll(".breed-selector-answer");
            var availableSet = available[questionKey];
            if (availableSet) {
                answers.forEach(function (answer) {
                    var value = answer.querySelector("input[data-key='value']").getAttribute("data-value");
                    if (availableSet[value]) {
                        answer.classList.remove("hidden");
                    }
                    else {
                        answer.classList.add("hidden");
                    }
                });
            }
        }
    });
}

function SetSelectedAnswers( encodedAnswers )
{
    var answers   = JSON.parse( atob( encodedAnswers ) );
    var questions = document.querySelectorAll( ".breed-selector-question-template" );
    var params    = { };

    questions.forEach( function( question )
    {
        var answerInputs = question.querySelectorAll( ".breed-selector-answer input[data-key='value']" );
        var key          = question.querySelector( "input[data-key='key']").getAttribute( "data-value" );
        var answered     = false;

        for ( var i = 0; i < answerInputs.length; i++ )
        {
            var answerInput = answerInputs[ i ];
            if ( ( answers[ key ] ) && ( answers[ key ].indexOf( answerInput.value ) >= 0 ) )
            {
                answerInput.closest( ".breed-selector-answer" ).classList.add( "breed-selector-answer-selected" );
                answered = true;
            }
            else
            {
                answerInput.closest( ".breed-selector-answer" ).classList.remove( "breed-selector-answer-selected" );
            }
        }

        if ( answered )
        {
            question.querySelector( ".breed-selector-answers" ).classList.add( "breed-selector-answers-answered" );
            question.classList.add( "breed-selector-question-answered" );
        }
        else
        {
            question.querySelector( ".breed-selector-answers" ).classList.remove( "breed-selector-answers-answered" );
            question.classList.remove( "breed-selector-question-answered" );
        }
    } );
}

function ShowIndividualResultScreen( petData )
{
    petData.species = window._selectedSpecies;
    
    var target = document.querySelector( ".breed-selector-individual-result-container" );
    target.querySelector( "[data-key='blog_url']" ).href = "";
    Specialise( target, petData );
    target.classList.remove( "hidden" );

    document.querySelector( ".breed-selector-results-container" ).classList.add( "hidden" );

    var param = btoa( JSON.stringify( petData ) );
    const url = new URL( location );
    url.searchParams.set( "breed", param );
    history.pushState( {}, "", url );

    window.scrollTo({top:0});
}

function BreedResultClicked( e )
{
    ShowIndividualResultScreen( e.currentTarget._petData );
}

function MakeResultParam( SPECIES_TYPE )
{
    var questions = document.querySelectorAll( ".breed-selector-question-template.breed-selector-question-answered" );
    var params    = { };

    questions.forEach( function( question )
    {
        var answers = question.querySelectorAll( ".breed-selector-answers-answered .breed-selector-answer-selected input[data-key='value']" );
        var key     = question.querySelector( "input[data-key='key']").getAttribute( "data-value" );

        params[key] = "";

        for ( var i = 0; i < answers.length; i++ )
        {
            if ( i > 0 )
            {
                params[ key ] += ",";
            }
            params[ key ] += answers[ i ].value;
        }
    } );

    params.type = SPECIES_TYPE;

    return ( params );
}

function ShowResults( SPECIES_TYPE, cb )
{
    var params = MakeResultParam( SPECIES_TYPE );
    window._breedSelectorAnswers = btoa( JSON.stringify( params ) );

    var submitButton = document.querySelector( ".meet-my-match" );
    submitButton.setAttribute( "disabled", "disabled" );

    BS_SendAPIRequest("/api/meta-match", "GET", params, function (err, response)
    {
        var target = document.getElementById("breed-selector-results");
        if ( debugView )
        {
            while ( target.firstChild )
            {
                target.firstChild.remove();
            }

            target.classList.remove( "hidden" );
        }

        //destroy old swiper instance
        destroySwiper();

        //hide the swiper container again
        var swiperContainer = document.querySelector('.breed-selector-results-container');
        if (debugView)
        {
            swiperContainer.classList.remove('hidden');
        }
        else
        {
            swiperContainer.classList.add('hidden');
        }

        if ( response )
        {
            var available = {};
            var template  = document.querySelector(".breed-selector-question-templates .breed-selector-result-template");
            var end       = response.length < 15 ? response.length : 15;

            if ( debugView )
            {
                end = response.length;
            }

            for ( var i = 0; i < response.length; i++ )
            {
                var row = response[i];

                if ( i < end )
                {
                    var clone = template.cloneNode(true);

                    Specialise( clone, row );

                    target.appendChild( clone );

                    if ( i < 15 )
                    {
                        swiperAddSlides( row );
                    }
                }

                // collect all the answer values that exist in the data set
                //for ( var key in row )
                //{
                //    if ( available[ key ] == undefined )
                //    {
                //        available[ key ] = { };
                //    }
                //    var answerSet = available[ key ];
                //    var value     = row[ key ];
                //    answerSet[ value ] = true;
                //}
                submitButton.removeAttribute( "disabled" );
            }
            //SetAnswerVisibility( params, available, SPECIES_TYPE );
            
            createSwiper('.breed-selector-results-container .swiper');
            DOMApply( swiperContainer, '.breed-selector-results-swiper .swiper-slide', function ( e ) { SetEventHandler( e, "click", BreedResultClicked ); } );
            DOMApply( document, '.breed-selector-result-back-container', function ( e ) { SetEventHandler( e, "click", IndividualResultBack ); } );
        }

        if ( cb )
        {
            cb( );
        }
    });
}

function IndividualResultBack()
{
    var qp = ParseQP();
    var url = new URL( window.location.href );
    if( qp.breed )
    {
        url.searchParams.delete( "breed" );
        history.pushState({}, "", url);
    }
    else if( qp.adoption )
    {
        url.searchParams.delete( "adoption" );
        history.pushState({}, "", url);
    }
    meetMyMatch();
}

document.addEventListener("DOMContentLoaded", function ()
{
    document.querySelectorAll(".breed-selector-answer").forEach(answer => {
        answer.addEventListener("click", function () {
            let checkbox = this.querySelector("input[type='checkbox']");
            if ( checkbox )
            {
                checkbox.checked = !checkbox.checked;
            }
        });
    });
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////
// breed selector implementation
/////////////////////////////////////////////////////////////////////////////////////////////////////////


function QuestionCompare(a, b) {
    return (a.position - b.position);
}

function GetQuestions(selectorData, SELECTED_SPECIES) {
    var result = [];

    selectorData.questions.forEach(function (question) {
        if (question.species == SELECTED_SPECIES) {
            InsertionSort(result, question, QuestionCompare, { "allowDuplicateKeys": true });
        }
    });

    return (result);
}

function QuestionClicked(e, SPECIES_TYPE) {
    if ((e.currentTarget.classList.contains("breed-selector-question-closed")) &&
        (e.currentTarget.classList.contains("breed-selector-question-answered"))) {
        e.currentTarget.classList.toggle("breed-selector-question-closed");
    }
}
function AnswerClicked(e, SPECIES_TYPE, IDM ) {
    if( e.currentTarget )
    {
        var element = e.currentTarget;
    }
    else
    {
        var element = e;
    }
    var answerParent = element.closest( ".breed-selector-answer" );
    if( !IDM )
    {
        if( answerParent.dataset?.radio == "true" )
        {
            var questionParent = answerParent.closest( ".breed-selector-answers" );
            var questionAnswers = questionParent.querySelectorAll( ".breed-selector-answer" );
            for( var i = 0; i < questionAnswers.length; i++ )
            {
                var answer = questionAnswers[ i ];
                if( answer != answerParent )
                {
                    if( answer.classList.contains( "breed-selector-answer-selected" ) )
                    {
                        answer.classList.remove( "breed-selector-answer-selected" );
                    }
                }
            }
        }
        element.classList.toggle("breed-selector-answer-selected");
    }

    var question = element.closest(".breed-selector-question-template");
    var answers = element.closest(".breed-selector-answers");
    var selected = answers.querySelectorAll(".breed-selector-answer-selected");

    if (selected.length > 0) {
        question.classList.add("breed-selector-question-answered");
        answers.classList.add("breed-selector-answers-answered");

        var answerString = "";

        for (var i = 0; i < selected.length; i++) {
            if (i > 0) {
                answerString += ", ";
            }
            answerString += selected[i].querySelector("[data-key='text']").innerText;
        }

        question.querySelector(".breed-selector-answer-summary").innerText = answerString;

        ShowResults(SPECIES_TYPE);
    }
    else {
        question.classList.remove("breed-selector-question-answered");
        answers.classList.remove("breed-selector-answers-answered");
    }
    CheckPercentageCompletion();
}

function NextClicked(e, SPECIES_TYPE)
{
    e.stopPropagation();
    e.preventDefault();

    var question = e.currentTarget.closest(".breed-selector-question-template");
    question.classList.add("breed-selector-question-closed");

    var prior = question.querySelector("input[data-key='prior']");
    if ((prior) && (prior.value == "true"))
    {
        var selected = question.querySelectorAll(".breed-selector-answer-selected");
        var lastSelected = selected[selected.length - 1];
        var curChange = lastSelected.previousSibling;

        while (curChange)
        {
            if (curChange.classList)
            {
                curChange.classList.add("breed-selector-answer-selected");
            }
            curChange = curChange.previousSibling;
        }
    }

    var next = question.nextSibling;
    if ((next) && (next.classList.contains("breed-selector-question-template"))) {
        next.classList.remove("breed-selector-question-closed");
        if (window.innerWidth < 500) {
             next.scrollIntoView({ behavior: "smooth", block: "nearest" });
        } 
    }
    else {
        // on to results
        ShowResults(SPECIES_TYPE);
    }
}

function PrevClicked(e, SPECIES_TYPE) {
    e.stopPropagation();
    e.preventDefault();

    var question = e.currentTarget.closest(".breed-selector-question-template");
    question.classList.add("breed-selector-question-closed");

    // Deselect all answers in the current question
    var selectedAnswers = question.querySelectorAll(".breed-selector-answer-selected");
    selectedAnswers.forEach(function (answer) {
        AnswerClicked({ currentTarget: answer }, SPECIES_TYPE);
        question.classList.remove("breed-selector-answer-selected");
        
    });

    question.classList.remove("breed-selector-question-answered");

    // Navigate to the previous question
    var prev = question.previousSibling;
    if (prev && prev.classList.contains("breed-selector-question-template")) {
        prev.classList.remove("breed-selector-question-closed");
        if (window.innerWidth < 500) {
            prev.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }

    // need to recalculate and update the progress ring
    CheckPercentageCompletion();
}

function SetSliderState(bar) {
    var container = bar.closest(".breed-selector-answers");
    var input = bar.querySelector("input");
    var progress = bar.querySelector(".breed-selector-slider-bar-inner");
    var thumb = bar.querySelector(".breed-selector-slider-thumb");
    var max = Number(input.max) - 1;
    var value = Number(input.value) - 1;
    var pc = value * 100 / max;
    var answers = container.querySelectorAll(".breed-selector-answer");
    thumb.setAttribute("style", `left: calc( ${pc}% - ${thumb.clientWidth / 2}px );`);
    progress.style.width = pc + "%";

    for (var i = 0; i < answers.length; i++) {
        if (i == value) {
            answers[i].classList.add("breed-selector-answer-selected");
        }
        else {
            answers[i].classList.remove("breed-selector-answer-selected");
        }
    }
}

function SliderAnswerClicked(e) {
    var container = e.currentTarget.closest(".breed-selector-slider-answers-wrapper");
    var answers = container.querySelectorAll(".breed-selector-answer");
    var idx = 0;
    var input = container.querySelector(".breed-selector-slider-bar input");

    while (idx < answers.length) {
        if (answers[idx] == e.currentTarget) {
            break;
        }
        idx++;
    }

    if (idx < answers.length) {
        input.value = idx + 1;
        SetSliderState(container.querySelector(".breed-selector-slider-bar"));
    }
}

function SliderBarSetup(bar)
{
    var container = bar.closest(".breed-selector-answers.breed-selector-swiper");
    if ( container )
    {
        var firstAnswer = container.querySelector(".breed-selector-answer");
        var progress = bar.querySelector(".breed-selector-slider-bar-inner");
        var input = bar.querySelector("input");
        var thumb = bar.querySelector(".breed-selector-slider-thumb");
        var reduction = firstAnswer.offsetWidth;
        var style = `max-width: calc( 100% - ${reduction}px ); left: ${reduction / 2}px;`;
        var max = Number(input.max) - 1;

        bar.setAttribute("style", style);
        input.value = Math.ceil(max / 2) + 1;

        DOMApply(container, ".breed-selector-answer", function (el) { SetEventHandler(el, "click", SliderAnswerClicked); });
        SetEventHandler(bar.querySelector("input"), "input", function (e) { SetSliderState(bar); });
        SetSliderState(bar);
    }
    else
    {
        console.log( "warning - invalid slider ", bar );
    }
}

function SwiperAnswerSetup(element)
{
    createSwiper(element);
}

function CreateOneQuestion( question, target, template, idx )
{
    var clone    = template.cloneNode(true);
    var images   = clone.querySelectorAll( "img" );
    var asyncs   = 1;

    function Done( )
    {
        asyncs--;

        if ( asyncs == 0 )
        {
            var content = clone.querySelector( ".breed-selector-question-content" );
            content.classList.add( `question-${question.position}` );

            if( question.radio == "true" )
            {
                var questionAnswers = clone.querySelectorAll( ".breed-selector-answer" );
                questionAnswers.forEach( function( answer )
                {
                    answer.dataset.radio = true;
                } );
            }
            else if( question.radio == "false" )
            {
                var multipleAnswerCopy = clone.querySelector( ".breed-selector-answer-all-multiple" );
                multipleAnswerCopy.classList.remove( "hidden" );
            }
            
            content.setAttribute("style", `height: auto;`);

            
            clone.removeAttribute( "style" );
            
            if ( idx > 0 )
            {
                clone.classList.add("breed-selector-question-closed");
            }
        }
    }

    DOMApply( clone, "img", function (e) { asyncs++; SetEventHandler( e, "load", Done ) } );
    clone.setAttribute( "style", "visibility: hidden;" );

    target.appendChild( clone );

    question.index = idx + 1;
    Specialise( clone, question );

    Done( );
}

function IDMClicked( e, SPECIES_TYPE )
{
    e.stopPropagation();
    e.preventDefault();
    
    var question = e.currentTarget.closest( ".breed-selector-question-content" );

    DOMApply( question, ".breed-selector-answer", function( e )
    {
        e.childNodes[ 0 ].parentNode.classList.add( "breed-selector-answer-selected" );
        AnswerClicked( e.childNodes[ 0 ].parentNode, SPECIES_TYPE, true );
    } );

    var next = question.querySelector( ".breed-selector-next-question" );
    next.click( );
}

function CreateQuestions(selectorData, SELECTED_SPECIES, SPECIES_TYPE)
{
    var target    = document.querySelector("#breed-selector-container .breed-selector-questions");
    var questions = GetQuestions(selectorData, SELECTED_SPECIES);
    var template  = document.querySelector(".breed-selector-question-templates .breed-selector-question-template");

    for ( var i = 0; i < questions.length; i++ )
    {
        var question = questions[ i ];

        CreateOneQuestion( question, target, template, i );
    }

    DOMApply(target, ".breed-selector-answer", function (e,) { SetEventHandler(e, "click", function (event) { AnswerClicked(event, SPECIES_TYPE) }); });
    DOMApply(target, ".breed-selector-next-question", function (e) { SetEventHandler(e, "click", function (event) { NextClicked(event, SPECIES_TYPE) }); });
    DOMApply(target, ".breed-selector-prev-question", function (e) { SetEventHandler(e, "click", function (event) { PrevClicked(event, SPECIES_TYPE) }); });
    DOMApply(target, ".breed-selector-question-template", function (e) { SetEventHandler(e, "click", QuestionClicked); });
    DOMApply(target, ".breed-selector-slider-bar", SliderBarSetup);
    DOMApply(target, ".breed-selector-swiper", SwiperAnswerSetup);
    DOMApply(target, ".idm-answer", function( e ) { SetEventHandler( e, "click", function (event) { IDMClicked( event, SPECIES_TYPE) } ); });
}

function StartupBreedSelectorForSpecies(SELECTED_SPECIES, SPECIES_TYPE)
{
    console.log("breed selector starting");

    // dog and cat data have different property names for the same actual thing.
    if ( SPECIES_TYPE == "scrumbles-cat-data" )
    {
        var catStuff = document.querySelectorAll( "[data-cat-key]" );
        catStuff.forEach( function( e )
        {
            e.setAttribute( "data-key", e.getAttribute( "data-cat-key" ) );
        } );
    }
    

    var selectorData = window._breedSelectorData;

    CreateQuestions(selectorData, SELECTED_SPECIES, SPECIES_TYPE);

    //in case you want to see all the results, shows up weird but i cant figure out why but still useable
    if (debugView) {
        document.getElementById('breed-selector-results').classList.remove("hidden");
    }
}

function swiperAddSlides(object)
{
    //receives object with all the information for one species of dog
    var totalQuestions = document.querySelectorAll('.breed-selector-question-template').length - 1;
    var template = document.querySelector('.swiper-slide-template');
    var slide = template.cloneNode(true);

    object.match = Math.round(object._rank / totalQuestions * 100);

    Specialise(slide, object);
    slide._petData = object;

    document.querySelector('.breed-selector-results-container .swiper-wrapper').appendChild(slide);
}

function meetMyMatch() {
    var slideCount = document.querySelector('.breed-selector-results-container .swiper-wrapper').childElementCount;
    var isThereResults = slideCount > 0;
    var errorBox = document.getElementsByClassName('meet-my-match-error')[0];

    if (!isThereResults) {
        const url = new URL(location);
        url.searchParams.delete("answers");
        url.searchParams.delete("breed");
        url.searchParams.delete("adoption");
        errorBox.innerHTML = `Sorry! No matches were found... Maybe try a different combination? <a href="${url.toString()}" class="meet-my-match-error__start">Start again</a>`;
    } else {
        errorBox.textContent = '';
        var results = document.querySelector('.breed-selector-results-container');
        results.classList.remove('hidden');

        var questions = document.querySelector(".breed-selector-container");
        questions.setAttribute("style", "display: none;");

        window.scrollTo({top:0,behavior:'smooth'});
    }

    var individualResultContainer = document.querySelector( ".breed-selector-individual-result-container" );
    var adoptionResultContainer   = document.querySelector( ".breed-selector-adoption-result-container" );
    if( individualResultContainer.classList.contains( "hidden" ) == false )
    {
        individualResultContainer.classList.add( "hidden" );
    }
    if( adoptionResultContainer.classList.contains( "hidden" ) == false )
    {
        adoptionResultContainer.classList.add( "hidden" );
    }

    const url = new URL(location);
    url.searchParams.set("answers", window._breedSelectorAnswers);
    history.pushState({}, "", url);
}

function createSwiper(selector) {
    var attempts = 0;

    function initializeSwiper() {
        var container = document.querySelector(selector);
      
        var slidesCurr = container.querySelectorAll(".swiper-slide");
        var slideCount = slidesCurr.length; // Get number of slides

        var swiper = new Swiper(selector, {
            direction: "horizontal",
            observer: true,
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 20,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: { 
                    slidesPerView: slideCount === 1 ? "auto" : 3, 
                    spaceBetween: 20, 
                    centeredSlides: false, 
                    centeredSlidesBounds: true 
                },
                1200: { 
                    slidesPerView: slideCount === 1 ? "auto" : 4, 
                    spaceBetween: 20, 
                    centeredSlides: false, 
                    centeredSlidesBounds: true 
                },
            },
        });
         
        return swiper; 
    }
    
    try {
        initializeSwiper();
    } catch (e) {
        if (attempts < 3) {
            attempts++;
            setTimeout(() => createSwiper(selector), 2000);
        }
    }
}

let adoptionContainer = document.querySelector('.breed-selector-adoption-swiper');
let slidesCurrent = adoptionContainer.querySelectorAll(".swiper-slide");
let slideCounter = slidesCurrent.length; 
let prevArrow = document.querySelector('.breed-selector-adoption-swiper .swiper-button-prev');
let nextArrow = document.querySelector('.breed-selector-adoption-swiper .swiper-button-next');
if (slideCounter <= 4) {
    prevArrow.classList.add('hidden');
    nextArrow.classList.add('hidden');
}

let individualContainer = document.querySelector('.breed-selector-results-container');
let individualSlidesCurrent = individualContainer.querySelectorAll(".swiper-slide");
let individualSlideCounter = individualSlidesCurrent.length; 
let prevArrowSingle = document.querySelector('.breed-selector-results-container .swiper-button-prev');
let nextArrowSingle = document.querySelector('.breed-selector-results-container .swiper-button-next');
if (individualSlideCounter <= 4) {
    prevArrow.classList.add('hidden');
    nextArrow.classList.add('hidden');
}

function destroySwiper() {
    var swiper = document.querySelector('.breed-selector-results-container .swiper');
    if (swiper.swiper) {
        swiper.swiper.destroy();
    }
    var wrapper = swiper.querySelector(".swiper-wrapper");
    while (wrapper.firstChild) {
        wrapper.firstChild.remove();
    }
}

function CheckPercentageCompletion() {
    var questionsAnswered = document.querySelectorAll('.breed-selector-question-answered').length;
    var totalQuestions = document.querySelectorAll('.breed-selector-question-template').length - 1;
    var percentageCompletion = questionsAnswered / totalQuestions * 100;
    setProgress(Math.round(percentageCompletion));
    if (questionsAnswered == totalQuestions) {
        if (document.querySelector('.meet-my-match').classList.contains('hidden')) {
            document.querySelector('.meet-my-match').classList.remove('hidden');
        }
    }
    else {
        if (!document.querySelector('.meet-my-match').classList.contains('hidden')) {
            document.querySelector('.meet-my-match').classList.add('hidden');
        }
    }
}

function setProgress(percent) {
    const circle = document.querySelector('.progress-ring-progress');
    const radius = circle.r.baseVal.value; // Radius of the circle
    const circumference = 2 * Math.PI * radius; // Circumference

    circle.style.strokeDasharray = `${circumference} ${circumference}`;
    circle.style.strokeDashoffset = circumference; // Initially hidden

    const offset = circumference - (percent / 100) * circumference;
    circle.style.strokeDashoffset = offset; // Set the visible portion
    document.querySelector('.percentage').textContent = `${percent}%`;
}

function moreInfoMenu(json) {
    object = JSON.parse(json);
    document.querySelector('.more-info-popup').classList.remove('hidden');
    document.querySelector('.popup-menu-dimmer').classList.remove('hidden');

    var dynamicText = document.querySelector('.learn-more-template').innerText;

    var img = '<img class="dynamic_field" data-key="blog_url_feature_image" src="https://cdn.shopify.com/s/files/1/0568/0450/7691/files/dog-5793625_1280.jpg?v=1733918852">';
    var mainInfo = `
        <p>${object.name}</p>
        <p>${object.match}%</p>
    `;
    var otherInfo = `
        <p>${object.size}</p>
        <p>${object.vocality}</p>
        <a href="${object.blog_url}">${dynamicText}</a>
    `;

    var main = document.querySelector('.more-info-popup-name');
    var other = document.querySelector('.more-info-popup-other');

    document.querySelector('.more-info-popup-img').innerHTML = img;
    main.innerHTML = mainInfo;
    other.innerHTML = otherInfo;
}

function SelectSpecies(type)
{
    var SPECIES_TYPE;
    var SELECTED_SPECIES;
    
    if (type == "dog")
    {
        SELECTED_SPECIES = "dog";
        SPECIES_TYPE = "scrumbles-dog-data";
        document.querySelector('.perfect-animal-dog').classList.remove('hidden');
    }
    else if (type == "cat")
    {
        SELECTED_SPECIES = "cat";
        SPECIES_TYPE = "scrumbles-cat-data";
        document.querySelector('.perfect-animal-cat').classList.remove('hidden');
    }

    window._selectedSpecies = SELECTED_SPECIES;
    document.querySelector('.landing-page').setAttribute("style", "display: none;");
    StartupBreedSelectorForSpecies(SELECTED_SPECIES, SPECIES_TYPE);

    Specialise( document.querySelector( ".breed-selector-results-container" ), { "species" : SELECTED_SPECIES } );

    return ( SPECIES_TYPE );
}

function BreedLinkClicked(e) {
    var breedLink = e.currentTarget.getAttribute("href");
    if (breedLink.indexOf("?breed=dog") >= 0) {
        e.stopPropagation();
        e.preventDefault();

        SelectSpecies("dog");
    }
    else if (breedLink.indexOf("?breed=cat") >= 0) {
        e.stopPropagation();
        e.preventDefault();

        SelectSpecies("cat");
    }
}

function ParseQPStr( str )
{
    var qpd   = { };
    var qp    = str;
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}

function ParseQP( )
{
    return ( ParseQPStr( window.location.search.substr( 1 ) ) );
}

function ShowAdoptionResultScreen( petData )
{
    var target = document.querySelector( ".breed-selector-adoption-result-container" );
    target.querySelector( "[data-key='adoption_url']" ).href = "";
    Specialise( target, petData );
    target.classList.remove( "hidden" );

    document.querySelector( ".breed-selector-results-container" ).classList.add( "hidden" );

    var param = btoa( encodeURIComponent( JSON.stringify( petData ) ) );
    const url = new URL( location );
    url.searchParams.set( "adoption", param );
    history.pushState( {}, "", url );

    window.scrollTo({top:0});
}


function ShowAdoptionPet( e )
{
    var slide        = e.currentTarget;
    var dataElements = slide.querySelectorAll( "[data-key]" );
    var petData      = { };

    dataElements.forEach(function (e) {
        if (e.tagName == "IMG") {
            petData[e.getAttribute("data-key")] = e.getAttribute("src");
        } else {
            petData[e.getAttribute("data-key")] = e.innerHTML;
        }
        e.setAttribute("width", "750px");
    });

    console.log( "show adoption pet", petData );
    ShowAdoptionResultScreen( petData );
}

function StartupBreedSelector()
{
    console.log("breed selector init");

    var qp = ParseQP( );
    var selectedType;

    if ( qp.species == "dog" )
    {
        selectedType = SelectSpecies( qp.species );
    }
    else if ( qp.species == "cat" )
    {
        selectedType = SelectSpecies( qp.species );
    }
    else
    {
        DOMApply( document, "a.breed-selector-link", function (e) { SetEventHandler( e, "click", BreedLinkClicked ); });
    }

    DOMApply( document, ".meet-my-match-container .meet-my-match", function( e ) { SetEventHandler(e, "click", meetMyMatch ) } );
    DOMApply( document, ".breed-selector-adoption-swiper .swiper-slide", function( e ) { SetEventHandler( e, "click", ShowAdoptionPet ) } );
    
    if ( qp.answers )
    {
        SetSelectedAnswers( qp.answers );

        ShowResults( selectedType, function( )
        {
            document.querySelector('.meet-my-match').classList.remove('disabled');
            meetMyMatch( );

            if ( qp.breed )
            {
                var petData = JSON.parse( atob( qp.breed ) );
                ShowIndividualResultScreen( petData );
            }
            else if ( qp.adoption )
            {
                var petData = JSON.parse( decodeURIComponent( atob( qp.adoption ) ) );
                ShowAdoptionResultScreen( petData );
            }
        } );
    }
}

// window.addEventListener("pageshow", BackButtonCacheBuster);

// function BackButtonCacheBuster() {
//     var historyTraversal = window.performance.getEntriesByType("navigation")[0].type === "back_forward";
//     console.log("history", historyTraversal)
//     if (historyTraversal) {
//         var adoptionResultContainer = document.querySelector('.breed-selector-adoption-result-container');
//         if (adoptionResultContainer && !adoptionResultContainer.classList.contains('hidden')) {
//             history.back();
//             adoptionResultContainer.classList.add('hidden');
//         } else {
//             window.location.reload(true);
//         }
//     }
// }

StartupBreedSelector( );

window.addEventListener( "popstate", StartupBreedSelector );

